module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('div', {
    staticClass: "select-container clearfix",
    staticStyle: {
      "margin-top": "2%",
      "margin-left": "2%",
      "float": "left"
    }
  }, [_c('span', {
    staticStyle: {
      "font-size": "30px",
      "font-weight": "bold"
    }
  }, [_vm._v("MOA未安装或版本不是最新")]), _c('br'), _c('br'), _vm._v(" "), _c('span', {
    staticStyle: {
      "font-size": "28px",
      "font-weight": "bold"
    }
  }, [_vm._v("一、背景")]), _c('br'), _c('br'), _vm._v(" "), _vm._m(0), _vm._v("\n          当前公司有几万员工，人员变动频繁，存在几万台个人终端和便携式电子设备，缺乏对入网终端统一的管理。我们无法得知究竟有多少终端连入我们的网络，无法对每台\n  接入网络的终端做认证，终端健康状态难以掌控。这给公司的IT安全带来很大风险，当出现类似于WannaCry勒索病毒时，我们无法快速得知哪些机器存在风险，也无法快速禁\n  止被感染或有风险的机器接入网络。基于此，我们希望做一个统一的终端安全管理系统，做到安全可视化，对设备做统一的认证和管控，提升IT安全。"), _c('br'), _vm._v(" "), _c('span', {
    staticStyle: {
      "font-size": "28px",
      "font-weight": "bold"
    }
  }, [_vm._v("二、自查方法")]), _c('br'), _c('br'), _vm._v(" "), _vm._m(1), _vm._v(" "), _vm._m(2), _vm._v(" "), _c('p', [_vm._v("1、请确认是否已安装MOA。")]), _vm._v(" "), _c('p', [_vm._v("    如未安装，请参照MOA 安装指导：美团安全管理客户端（MOA）安装\n  ("), _c('span', {
    staticStyle: {
      "color": "#63B8FF",
      "text-decoration": "underline",
      "cursor": "pointer"
    },
    on: {
      "click": function($event) {
        return _vm.routerUrl('/moaInstallForWin')
      }
    }
  }, [_vm._v("Windows操作系统安装MOA")]), _vm._v("，\n  "), _c('span', {
    staticStyle: {
      "color": "#63B8FF",
      "text-decoration": "underline",
      "cursor": "pointer"
    },
    on: {
      "click": function($event) {
        return _vm.routerUrl('/moaInstallForMac')
      }
    }
  }, [_vm._v("macOS操作系统安装MOA")]), _vm._v(")\n  ")]), _vm._v(" "), _c('p', [_vm._v("2、若已安装，请确认是否是最新版MOA。")]), _vm._v(" "), _c('p', [_vm._v("    查看MOA版本方式：MOA版本查看（"), _c('span', {
    staticStyle: {
      "color": "#63B8FF",
      "text-decoration": "underline",
      "cursor": "pointer"
    },
    on: {
      "click": function($event) {
        return _vm.routerUrl('/moaVersionView')
      }
    }
  }, [_vm._v("MOA版本查看")]), _vm._v("）。\n  ")]), _c('p', {
    staticStyle: {
      "color": "red"
    }
  }, [_vm._v("注意：因MOA部分旧版本不支持自动更新升级，在查看版本时获取不到最新版信息，MOA当前最新版本为：")]), _vm._v(" "), _c('p', [_vm._v("        MAC 上MOA最新版本：【1.3.1.0 】（要求macOS操作系统版本 > 10.11）")]), _vm._v(" "), _c('p', [_vm._v("        Windows上MOA最新版本： 【1.3.0.0 】（要求 Windows 7及以上操作系统版本）")]), _vm._v("\n  3、安装时若遇到问题，请参考（\n  "), _c('span', {
    staticStyle: {
      "color": "#63B8FF",
      "text-decoration": "underline",
      "cursor": "pointer"
    },
    on: {
      "click": function($event) {
        return _vm.routerUrl('/macOS_FAQ')
      }
    }
  }, [_vm._v("macOS FAQ")]), _vm._v("，\n  "), _c('span', {
    staticStyle: {
      "color": "#63B8FF",
      "text-decoration": "underline",
      "cursor": "pointer"
    },
    on: {
      "click": function($event) {
        return _vm.routerUrl('/windows_FAQ')
      }
    }
  }, [_vm._v("windows FAQ")]), _vm._v("，\n  "), _c('span', {
    staticStyle: {
      "color": "#63B8FF",
      "text-decoration": "underline",
      "cursor": "pointer"
    },
    on: {
      "click": function($event) {
        return _vm.routerUrl('/other_FAQ')
      }
    }
  }, [_vm._v("其他 FAQ")]), _vm._v("）或联系6000工作台协助解决。 "), _c('br'), _vm._v(" "), _c('p', [_vm._v("若以上没有解决您的问题，请联系6000帮助台进行协助解决")]), _vm._v(" "), _vm._m(3), _vm._v(" "), _vm._m(4), _vm._v(" "), _vm._m(5), _vm._v(" "), _c('p', [_vm._v("2、若您本机已经安装了DLP和MOA，仍然跳出该提示，可能是您有多台机器用于过办公，另外机器上未安装DLP，请在另一台用于办公电脑上也安装运行DLP。")]), _vm._v(" "), _c('p', [_vm._v("    可通过：https://report-mon.sankuai.com/report/api/check_status?mis_id=您的mis号 排查，DLP安装状态是否是“Y“。")]), _vm._v(" "), _vm._m(6), _vm._v(" "), _c('p', [_vm._v("若以上没有解决您的问题，请联系6000帮助台进行协助解决")]), _vm._v(" "), _c('br'), _vm._v(" "), _c('span', {
    staticStyle: {
      "font-size": "28px",
      "font-weight": "bold"
    }
  }, [_vm._v("三、常见问题")]), _c('br'), _c('br'), _vm._v(" "), _vm._m(7), _vm._v(" "), _c('span', {
    staticStyle: {
      "color": "rgb(29, 120, 205)"
    }
  }, [_vm._v("Q：我有紧急的事情需要访问线上系统，但是暂时无法安装MOA，怎么办？")]), _c('br'), _vm._v("\n  A：可以点击【\n  "), _c('span', {
    staticStyle: {
      "color": "#63B8FF",
      "text-decoration": "underline",
      "cursor": "pointer"
    },
    on: {
      "click": function($event) {
        return _vm.routerUrl('/whiteApply')
      }
    }
  }, [_vm._v("临时白名单申请地址")]), _vm._v("\n  】，申请临时白名单。"), _c('span', {
    staticStyle: {
      "color": "rgb(240, 94, 80)"
    }
  }, [_vm._v("有效期4小时，最多申请3次。")]), _vm._v(" "), _c('br'), _c('br'), _vm._v(" "), _c('span', {
    staticStyle: {
      "color": "rgb(29, 120, 205)"
    }
  }, [_vm._v("Q：我已经安装了MOA，为什么还是无法访问办公系统？")]), _c('br'), _vm._v(" "), _c('p', {
    staticStyle: {
      "text-align": "start"
    }
  }, [_vm._v("A：请确认安装MOA后，是否已打开MOA界面根据提示使用大象扫码登录完成注册工作。")]), _vm._v(" "), _c('p', {
    staticStyle: {
      "text-align": "start",
      "margin-left": "20px"
    }
  }, [_vm._v("查看MOA是否安装："), _c('span', {
    staticStyle: {
      "color": "#63B8FF",
      "text-decoration": "underline",
      "cursor": "pointer"
    },
    on: {
      "click": function($event) {
        return _vm.routerUrl('/verifyMoaIsInstall')
      }
    }
  }, [_vm._v("如何判断MOA是否已经安装")]), _vm._v("（确定安装5分钟后，数据同步完成）。")]), _vm._v(" "), _c('p', {
    staticStyle: {
      "text-align": "start",
      "margin-left": "20px"
    }
  }, [_vm._v("如还有问题可联系6000协助您解决。")]), _c('br'), _vm._v(" "), _vm._m(8), _vm._v(" "), _vm._m(9), _vm._v(" "), _c('br'), _vm._v(" "), _vm._m(10), _vm._v(" "), _vm._m(11), _vm._v(" "), _vm._m(12), _vm._v(" "), _vm._m(13), _vm._v(" "), _c('p', {
    staticStyle: {
      "text-align": "start"
    }
  }, [_vm._v("    2、需要接入公司网络")]), _vm._v(" "), _vm._m(14), _vm._v(" "), _vm._m(15), _vm._v(" "), _vm._m(16)])])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticStyle: {
      "background": "#FFE4E1",
      "width": "100%",
      "height": "30px"
    }
  }, [_c('span', [_c('p', [_vm._v("根据公司安全规定，未安装安全管理客户端（MOA），会被限制访问办公系统。")])])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticStyle: {
      "background": "#b3fff2",
      "width": "100%",
      "height": "30px"
    }
  }, [_c('span', [_c('p', [_vm._v("如果是「请检查当前计算机MOA是否安装或MOA版本是否最新」 拦截提示，如下：")])])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', [_c('img', {
    attrs: {
      "src": require("../assets/moaUninstall/moaUninstall_pic01.png"),
      "width": "540px",
      "height": "360px"
    }
  })])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticStyle: {
      "background": "#b3fff2",
      "width": "100%",
      "height": "30px"
    }
  }, [_c('span', [_c('p', [_vm._v("如果是「您已被限制访问办公系统，请及时安装MOA/DLP产品」拦截提示，如下：")])])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', [_c('img', {
    attrs: {
      "src": require("../assets/moaUninstall/moaUninstall_pic02.png"),
      "width": "740px",
      "height": "500px"
    }
  })])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', [_vm._v("1、跳出该提示说明您本地电脑未安装DLP或MOA产品，请按照拦截提示指导移步IT门户(\n  "), _c('a', {
    staticClass: "ct-link",
    staticStyle: {
      "color": "#1890ff"
    },
    attrs: {
      "data-auto_update": "0",
      "data-pageid": "",
      "href": "https://itportal.sankuai.com/",
      "target": "_blank",
      "rel": "noopener"
    }
  }, [_vm._v("https://itportal.sankuai.com/")]), _vm._v("\n  )下载安装。")])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', [_c('img', {
    attrs: {
      "src": require("../assets/moaUninstall/moaUninstall_pic03.png"),
      "width": "1040px",
      "height": "100px"
    }
  })])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticStyle: {
      "background": "#e5f5c9",
      "width": "100%",
      "height": "30px"
    }
  }, [_vm._v("申请临时白名单，仅有4小时有效期。"), _c('span', {
    staticStyle: {
      "color": "red"
    }
  }, [_vm._v("若因特殊原因，需要较长时间，请联系6000。")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', [_c('span', {
    staticStyle: {
      "color": "rgb(0, 0, 0)"
    }
  }, [_vm._v("为什么安装杀毒软件还要安装MOA？")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', [_c('span', {
    staticStyle: {
      "color": "rgb(0, 0, 0)"
    }
  }, [_vm._v("A：杀毒软件主要用于终端病毒和恶意软件的查杀。MOA是公司终端设备统一认证和管控的客户端，主要用于检测员工PC 终端的安全状态以及辅助员工网络接入，对员工业务操作不会影响，不会收集员工个人隐私信息。")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', [_c('span', {
    staticStyle: {
      "color": "rgb(29, 120, 205)"
    }
  }, [_vm._v("Q: 怎样区分我的电脑是否需要安装MOA？")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', [_c('span', {
    staticStyle: {
      "color": "rgb(0, 0, 0)"
    }
  }, [_vm._v("A：符合以下任意一个条件的电脑都需要安装，无论是私人电脑，还是公司配发的电脑。若有多台，均需安装MOA。")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', [_c('span', {
    staticStyle: {
      "color": "rgb(0, 0, 0)"
    }
  }, [_vm._v("    1、用于办公用途的电脑，办公用途包括但不限于:")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('ul', {
    staticStyle: {
      "margin-left": "40px"
    }
  }, [_c('li', [_c('p', [_vm._v("使用浏览器登录使用任何公司web系统，包括但不限于web邮件、sankuai门户、HR平台等")])]), _vm._v(" "), _c('li', [_c('p', [_vm._v("使用outlook、apple mail等邮件客户端软件收发邮件")])]), _vm._v(" "), _c('li', [_c('p', [_vm._v("使用git等软件连接代码仓库进行开发工作")])]), _vm._v(" "), _c('li', [_c('p', [_vm._v("直接登录或使用跳板机登录公司服务器")])]), _vm._v(" "), _c('li', [_c('p', [_vm._v("存储公司资料的机器")])]), _vm._v(" "), _c('li', [_c('p', [_vm._v("其它")])])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('ul', {
    staticStyle: {
      "margin-left": "40px"
    }
  }, [_c('li', [_c('p', [_vm._v("通过有线连接公司网络")])]), _vm._v(" "), _c('li', [_c('p', [_vm._v("通过无线连接公司网络")])])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', [_c('span', {
    staticStyle: {
      "color": "rgb(29, 120, 205)"
    }
  }, [_vm._v("Q：MOA会做什么事情，会监控我的电脑吗？")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', {
    staticStyle: {
      "text-align": "start"
    }
  }, [_vm._v("A："), _c('span', {
    staticStyle: {
      "color": "rgb(0, 0, 0)"
    }
  }, [_vm._v("MOA是公司终端设备统一认证和管控的客户端，主要用于检测员工PC 终端的安全状态以及辅助员工网络接入，对员工业务操作不会影响。")]), _c('strong', [_c('span', {
    staticStyle: {
      "color": "rgb(240, 94, 80)"
    }
  }, [_vm._v("请大家放心，MOA不会监控员工操作电脑行为、聊天记录、隐私数据等。")])])])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-65855f70!./~/vue-loader/lib/selector.js?type=template&index=0!./src/views/moaUninstall.vue
// module id = 649
// module chunks = 1